<style lang="scss">
@media screen and (min-width: 55rem) {
  .storelist-container {
    display: flex;
    width: 100%;
    justify-content: center;

    .storeList {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .store-item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        margin-top: 7rem;
        .store-item-title {
          font-size: 2rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 400;
          color: #e5004f;
        }
        .store-item-subtitle {
          margin-top: 0.4rem;
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #7d7d7d;
          line-height: 1rem;
        }
        .store-item-block {
          margin-top: 2rem;
          margin-bottom: 2rem;
          width: 43px;
          height: 7px;
          background: #e5004f;
        }

        .store-item-list {
          width: 100%;
          box-shadow: 0px 0px 4px #dfd9d9a6;
          display: flex;
          flex-direction: row;
          border-radius: 1rem;
          min-height: 35rem;
          .store-item-list-left {
            height: 100%;
            width: 50%;
            background-position: top 30%;
            background-size: cover;
            min-height: 45rem;
          }
          .store-item-list-right {
            height: 100%;
            width: 50%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            min-height: 45rem;
            .store-item-list-right-list {
              height: 100%;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-content: center;
              flex-wrap: wrap;
              .store-item-list-right-item {
                width: 50%;
                .store-item-list-right-item-text {
                  width: 100%;
                  text-align: center;
                  font-size: 1.375rem;
                  font-family:  'PingFang SC','Microsoft YaHei';
                  font-weight: 400;
                  color: #000000;
                  line-height: 2.625rem;
                  opacity: 0.5;
                  display: block;
                  overflow: hidden;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .storelist-container {
    display: flex;
    width: 100%;
    justify-content: center;
    .storeList {
      width: 80%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .store-item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        margin-top: 7rem;

        .store-item-title {
          font-size: 2rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 400;
          color: #e5004f;
        }
        .store-item-subtitle {
          margin-top: 0.4rem;
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #7d7d7d;
          line-height: 1rem;
        }
        .store-item-block {
          margin-top: 2rem;
          margin-bottom: 1rem;
          width: 43px;
          height: 7px;
          background: #e5004f;
        }

        .store-item-list {
          width: 100%;
          box-shadow: 0px 0px 4px #dfd9d9a6;

          display: flex;
          flex-direction: column;
          .store-item-list-left {
            height: 25rem;
            width: 100%;
            background-size: cover;
          }
          .store-item-list-right {
            min-height: 10rem;
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .store-item-list-right-list {
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 100%;
              overflow: hidden;
              flex-wrap: wrap;

              .store-item-list-right-item {
                width: 80%;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 1rem;

                .store-item-list-right-item-text {
                  line-height: 2.625rem;
                  opacity: 0.5;
                  font-size: 1.375rem;
                  font-family:  'PingFang SC','Microsoft YaHei';
                  font-weight: 400;
                  color: #000000;
                }
              }
            }
          }
        }
      }
    }
  }
}

.text_center {
  justify-content: center !important;
}
</style>

<template>
  <div class="storelist-container">
    <div class="storeList">
      <div
        v-for="(item, index) in this.store_list"
        :key="index"
        class="store-item"
      >
        <div class="store-item-title">{{ item.title }}</div>
        <div class="store-item-subtitle">{{ item.subtitle }}</div>
        <div class="store-item-block"></div>
        <div class="store-item-list">
          <div
            class="store-item-list-left"
            :style="`background-image: url('${item.background_image}')`"
          ></div>
          <div class="store-item-list-right">
            <div
              class="store-item-list-right-list"
              v-bind:class="{ text_center: item.store_item.length == 1 }"
            >
              <div
                class="store-item-list-right-item"
                v-for="(it, i) in item.store_item"
                :key="i"
              >
                <a
                  :href="`https://uri.amap.com/marker?position=${it.config.x_position},${it.config.y_position}`"
                  ><div class="store-item-list-right-item-text">
                    {{ it.name }}
                  </div></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchStore } from "@/yintai/api/store";

export default {
  name: "storeList",
  components: {},
  data() {
    return {
      store_list: [],
    };
  },
  async mounted() {
    const result = await fetchStore();
    let response = result.data.data.data;
    for (let i = 0; i < response.length; i++) {
      response[i].store_item = JSON.parse(response[i].store_item);
    }
    this.store_list = response;
  },
  methods: {},
};
</script>
